module.exports = __webpack_public_path__ + "static/media/eyes_security.875cfc82.png";